import Axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import config from '../../Config/key';
import { DEFAULT_BCC_EMAIL } from '../../Config/mailConfig';
import { Table, Button, message, Typography, Select, Modal, Input } from 'antd';
import { userRole } from '../../Config/userRole';
import { useSelector } from 'react-redux';
import { resolveCompanyName } from '../../../utils/companyName';
// テーブル強化 PJ Ph.3 拡大: 列リサイズ + ソート + 省略
import {
  PageContainer,
  useResizableColumns,
  ellipsisColumn,
  textSorter,
} from '../../common';
const ExcelJS = require('exceljs');
const { Text } = Typography;
const { confirm } = Modal;
const { Option } = Select;

const SurveyMailSendPage = (props) => {
  const [isAnswerd, setIsAnswerd] = useState(9);
  const [tUsers, setTUsers] = useState([]); //グループフィルタリングされたユーザ一覧（全体）
  const [gUsers, setGUsers] = useState([]); //グループ・サーベイシーズンでフィルタリングされたユーザ一覧
  const [searchName, setSearchName] = useState(''); // 対象者リスト内の名前検索（表示絞り込みのみ）
  const [searchEmail, setSearchEmail] = useState(''); // 対象者リスト内のメール検索（表示絞り込みのみ）
  const [groups, setGroups] = useState([]); //グループ名とグループコード
  const [selGroupInfo, setSelGroupInfo] = useState([]); //グループ名とグループコード
  const [surveySeason, setSurveySeason] = useState([]);
  const [selGroupCode, setSelGroupCode] = useState(''); //選択されたグルプコード
  const [survey, setSurvey] = useState([]); //サーベイ名とサーベイコード
  const [selSurvey, setSelSurvey] = useState([]); //サーベイ名とサーベイコード
  const [questionSet, setQuestionSet] = useState([]); //全ての設問セット
  const [selSurveyId, setSelSurveyId] = useState(''); //選択したサーベイID
  const [selSurveySeasonId, setSelSurveySeasonId] = useState(''); //選択したサーベイID
  const [selSurveySeasonInfo, setSelSurveySeasonInfo] = useState({}); //選択したサーベイID
  const [selSurveySeasonIdFilter, setSelSurveySeasonIdFilter] = useState(''); //選択したサーベイID
  const [selQuestionSetId, setSelQuestionSetId] = useState(''); //選択した設問セットID
  const [selQuestionSetInfo, setSelQuestionSetInfo] = useState({}); //選択した設問セットID
  const [mtInfo, setMtInfo] = useState([]);
  const [selMtId, setSelMtId] = useState('');
  const [ccMailValue, setCCMailValue] = useState('');
  const [bccMailValue, setBCCMailValue] = useState(DEFAULT_BCC_EMAIL);
  const [testMailValue, setTestMailValue] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const usr = useSelector((state) => state.user);
  //9:管理者９が最高管理者
  // const userRole = [
  //   '停止中',
  //   '学習者',
  //   '管理者',
  //   'その他',
  //   'その他',
  //   'その他',
  //   'その他',
  //   'その他',
  //   'その他',
  //   '最高管理者',
  // ];

  const readDB = async () => {
    try {
      if (!usr.userData) return null;
      // console.log(usr.userData);

      const [surveyInfo, groupInfo, seasonInfo, mtInfo] = await Promise.all([
        Axios.get('/api/survey/'), //DBからサーベイ情報取得
        Axios.get('/api/group/'), //DBからグループ情報取得
        Axios.get('/api/surveySeason/'), //DBからシーズン情報取得
        Axios.get('/api/mailTemplate/'),
        // Axios.get(config.USER_SERVER), //全てのユーザの習得（管理者以外）
      ]);
      setGroups(groupInfo.data.groups);
      setSurvey(surveyInfo.data.survey);
      setSurveySeason(seasonInfo.data.surveySeason);
      setMtInfo(mtInfo.data.mailTemplate);
      setGUsers([]);
      setTUsers([]);
      if (!groups) throw 'グループ取得に失敗しました。';
      if (!survey) throw 'サーベイ取得に失敗しました。';
      if (!seasonInfo) throw 'サーベイシーズン取得に失敗しました。';
      if (!mtInfo) throw 'メールテンプレート取得に失敗しました。';
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
    // console.log({ Users });
  }, [usr]);

  //リストフィルタリング
  const filterDatasource = async (groupCode) => {
    message.loading({ content: '読み込み中...', key: 'loading', duration: 20 });
    const res = await Axios.get(`${config.USER_SERVER}/group/${groupCode}`);
    // console.log({ res });
    let userData = res.data.users;
    await userData.map((user) => {
      user.fullName = user.lastname + ' ' + user.name;
      user.roleText = userRole[user.role];
      if (user.survey_token.length === 0) {
        user.takeTokenCnt = 0;
        user.usedTokenCnt = 0;
        user.surveyProgress = 0;
      } else {
        user.takeTokenCnt = user.survey_token.length;
        user.usedTokenCnt = user.survey_token.filter(function (tokenInfo) {
          return tokenInfo.survey_status === 5; //実施済み：5
        }).length;
        user.surveyProgress = (user.usedTokenCnt / user.takeTokenCnt) * 100;
      }
      return user;
    });
    setGUsers(userData);
    setTUsers(userData);
    message.success({
      content: '読み込み完了！',
      key: 'loading',
      duration: 2,
    });
  };

  //グループを変更した場合
  const onChangeGroup = async (value) => {
    // console.log(`selected ${value}`);
    setSelGroupCode(value);
    filterDatasource(value); //リストフィルタリング
    const selGroup = groups.find((item) => item.group_code === value);
    // console.log({ selGroup });
    setSelGroupInfo(selGroup);
    setQuestionSet([]);
    setSelSurveyId('');
    setSelSurveySeasonId('');
    setSelSurveySeasonIdFilter('');
    setSelQuestionSetId('');
    setIsAnswerd(9);
    setSelectedRowKeys([]);
    // setSelSurveySeasonInfo([]);
  };

  //サーベイシーズンを変更した場合
  const onChangeSeason = async (value) => {
    setSelSurveySeasonId(value);
    const selSeasonInfo = selGroupInfo.survey_season.find(
      (item) => item._id === value
    );
    const arrQuestionSet = selSeasonInfo.question_set;
    setSelSurveySeasonInfo(selSeasonInfo);
    setSelSurveyId(selSeasonInfo.survey_id);
    setQuestionSet(arrQuestionSet);
    setSelQuestionSetId('');
    setIsAnswerd(9);
    setSelectedRowKeys([]);
    // if (arrQuestionSet.length > 0) {
    //   setSelQuestionSetId(arrQuestionSet[0]._id);
    // } else {
    //   setSelQuestionSetId('');
    // }
  };
  //サーベイシーズンを変更した場合
  const onChangeSeasonFilter = async (value) => {
    await onChangeSeason(value);
    setSelSurveySeasonIdFilter(value);
    const gUserArr = [];
    for (let i = 0; i < tUsers.length; i++) {
      const element = tUsers[i];
      let token = {};
      if (element.survey_token) {
        token = element.survey_token.find(
          (item) => item.survey_season_id === value
        );
      }
      if (token) {
        gUserArr.push(element);
      }
    }
    // console.log({ gUserArr });
    setGUsers(gUserArr);
  };

  //設問セットを変更した場合
  const onChangeQuestionSet = (value) => {
    setSelQuestionSetId(value); //選択した設問セットIDを格納
    const selQuestionSet = questionSet.find((item) => item._id === value);
    setSelQuestionSetInfo(selQuestionSet); //現在選択したQuestionSet
    // console.log({ selQuestionSet });

    setIsAnswerd(9);
    setSelectedRowKeys([]);
    // console.log({ gUsers });
    const gUserArr = [];
    for (let i = 0; i < tUsers.length; i++) {
      const element = tUsers[i];
      let token = {};
      if (element.survey_token) {
        // if (isAnswerd === 9) {
        token = element.survey_token.find(
          (item) =>
            item.question_set_id === value &&
            item.survey_season_id === selSurveySeasonIdFilter
        );
        // } else {
        //   token = element.survey_token.find(
        //     (item) =>
        //       item.question_set_id === value &&
        //       item.survey_season_id === selSurveySeasonIdFilter &&
        //       item.survey_status === isAnswerd
        //   );
        // }
      }
      if (token) {
        gUserArr.push(element);
      }
    }
    // console.log({ gUserArr });
    setGUsers(gUserArr);
  };

  //実施有無
  const onChangeAnswer = (value) => {
    // console.log({ value });
    setIsAnswerd(value);

    setSelectedRowKeys([]);
    if (value === 99) {
      return;
    }

    const gUserArr = [];
    for (let i = 0; i < tUsers.length; i++) {
      const element = tUsers[i];
      let token = {};
      if (element.survey_token) {
        if (value === 9) {
          if (selQuestionSetId) {
            token = element.survey_token.find(
              (item) =>
                item.question_set_id === selQuestionSetId &&
                item.survey_season_id === selSurveySeasonIdFilter
            );
          } else {
            token = element.survey_token.find(
              (item) => item.survey_season_id === selSurveySeasonIdFilter
            );
          }
        } else {
          if (selQuestionSetId) {
            token = element.survey_token.find(
              (item) =>
                item.question_set_id === selQuestionSetId &&
                item.survey_season_id === selSurveySeasonIdFilter &&
                item.survey_status === value
            );
          } else {
            token = element.survey_token.find(
              (item) =>
                item.survey_season_id === selSurveySeasonIdFilter &&
                item.survey_status === value
            );
          }
        }
      }
      if (token) {
        gUserArr.push(element);
      }
    }
    // console.log({ gUserArr });
    setGUsers(gUserArr);
  };

  //yyyy/mm/dd hh:mm
  const ymdhms = (tdate) => {
    let date = new Date(tdate);
    //console.log({ date });
    return (
      date.getFullYear() +
      '/' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + date.getDate()).slice(-2) +
      ' ' +
      ('0' + date.getHours()).slice(-2) +
      ':' +
      ('0' + date.getMinutes()).slice(-2)
      // date.getMilliseconds()
    );
  };

  //メール配信
  const sendMailHandler = async () => {
    let mailList = {}; //最終分類用
    try {
      // console.log({ rowKeys });
      message.loading({ content: 'メール配信中...', key: 'mail' });
      const selMtInfo = mtInfo.find((item) => item._id === selMtId);
      const ccString = ccMailValue
        .replace(/\s+/g, '') //文字列の中の空白を削除
        .replace(/(^[;]+)|([;]+$)/g, ''); //文字列前後の「;」を削除
      const bccString = bccMailValue
        .replace(/\s+/g, '') //文字列の中の空白を削除
        .replace(/(^[;]+)|([;]+$)/g, ''); //文字列前後の「;」を削除
      let cc = [];
      let bcc = [];
      let ccArr = [];
      let bccArr = [];
      if (ccString) {
        cc = ccString.split(';');
        cc.map((element) => {
          ccArr.push({ email: element });
        });
      }
      if (bccString) {
        bcc = bccString.split(';');
        bcc.map((element) => {
          bccArr.push({ email: element });
        });
      }

      let personalizations = [];
      const targetUsers = isAnswerd === 99
        ? gUsers.filter((u) => selectedRowKeys.includes(u._id))
        : gUsers;
      targetUsers.map((record) => {
        let substitutions = {};
        let init_pass = '';
        if (record.change_password || !record.init_pass) {
          init_pass = '（登録済みパスワード）';
        } else {
          init_pass = record.init_pass;
        }
        if (
          (selQuestionSetInfo.survey_code === '40010' ||
            selQuestionSetInfo.survey_code === '60020') &&
          selQuestionSetInfo.sub_type === '5'
        ) {
          //360診断の協力者の場合
          substitutions = {
            email: record.email,
            fullname: `${record.lastname} ${record.name}`,
            familyname: record.lastname,
            // 代表会社名（系列会社ありグループはシーズン設定に従う。サーバー予約送信と同一規則）
            company: resolveCompanyName(selGroupInfo, record, selSurveySeasonInfo),
            // 部署名（所属①〜⑦。2026-09 に ⑥⑦ を追加）。未登録時は空文字で置換し「undefined」露出を防ぐ。
            // department1 は department（第1階層）と同値の別名。
            department: record.department || '',
            department1: record.department || '',
            department2: record.department2 || '',
            department3: record.department3 || '',
            department4: record.department4 || '',
            department5: record.department5 || '',
            department6: record.department6 || '',
            department7: record.department7 || '',
            tname: selSurveySeasonInfo.t_name,
            target: searchUser(record._id),
            emp_no: record.emp_no,
            init_pass: init_pass,
          };
        } else {
          substitutions = {
            email: record.email,
            fullname: `${record.lastname} ${record.name}`,
            familyname: record.lastname,
            // 代表会社名（系列会社ありグループはシーズン設定に従う。サーバー予約送信と同一規則）
            company: resolveCompanyName(selGroupInfo, record, selSurveySeasonInfo),
            // 部署名（所属①〜⑦。2026-09 に ⑥⑦ を追加）。未登録時は空文字で置換し「undefined」露出を防ぐ。
            // department1 は department（第1階層）と同値の別名。
            department: record.department || '',
            department1: record.department || '',
            department2: record.department2 || '',
            department3: record.department3 || '',
            department4: record.department4 || '',
            department5: record.department5 || '',
            department6: record.department6 || '',
            department7: record.department7 || '',
            tname: selSurveySeasonInfo.t_name,
            emp_no: record.emp_no,
            init_pass: init_pass,
          };
        }
        personalizations.push({
          to: [
            {
              email: record.email,
              name: `${record.lastname} ${record.name}様`,
            },
          ],
          cc: ccArr,
          bcc: bccArr,
          substitutions: substitutions,
        });
      });
      mailList = {
        personalizations: personalizations,
        from: {
          email: selMtInfo.from_mail, // 送信元アドレス
          name: selMtInfo.from_name, // 送信者名
        },
        subject: selMtInfo.subject,
        html: selMtInfo.body.replace(/\r?\n/g, '<br>'),
        substitutionWrappers: ['{$', '$}'],
        headers: {
          'X-Sent-Using': 'SendGrid-API',
        },
      };
      // console.log({ mailList });
      // console.log({ selSurveySeasonInfo });
      //----------------------------テスト用--------------------------------------
      // const sendMailResult = { data: { success: false } };
      // console.log('メールはテストのため配信されていません。');
      //----------------------------本番用---------------------------------------
      const sendMailResult = await Axios.post('/api/sendMail', {
        mailList: mailList,
        operation_log: 'SurveyMailSend',
        // サーベイシーズン情報に基づくメール変数6種をサーバー側で補強するためのコンテキスト
        // survey_code はシーズン自体から取得（設問マッチングしないサーベイでは
        // selQuestionSetInfo が空のため undefined になってしまう）
        mailContext: {
          survey_season_id: selSurveySeasonInfo._id,
          survey_code: selSurveySeasonInfo.survey_code,
          question_set_sub_type: selQuestionSetInfo.sub_type,
        },
      });
      //------------------------------------------------------------------------
      if (sendMailResult.data.success) {
        message.success({
          content: 'メール送信完了！',
          key: 'mail',
          duration: 2,
        });
        return sendMailResult;
      } else {
        message.error({
          // サーバーが返す具体的な失敗原因を表示（無ければ汎用文言）
          content: sendMailResult.data.error || 'メール送信に失敗しました。',
          key: 'mail',
          duration: 4,
        });
        // console.log({ sendMailResult });
        throw new Error('メール送信に失敗しました。');
      }
    } catch (error) {
      console.log(error);
      message.error({
        content: 'メール配信で問題が発生しました。',
        key: 'mail',
        duration: 2,
      });
    }
  };

  // const searchUser = (userId) => {
  //   //1. selSurveySeasonInfo.relation_360のbossとpartnerを検索してuserIdを探す
  //   //2. 探したオブジェクトのuser_id（本人のIDを取得
  //   //3. _idでtUserを検索して名前、所属などの情報をReturn
  //   let heroId = [];
  //   selSurveySeasonInfo.relation_360.map((item) => {
  //     item.boss.map((item2) => {
  //       if (item2 === userId) heroId = item.user_id;
  //     });
  //     item.partner.map((item2) => {
  //       if (item2 === userId) heroId = item.user_id;
  //     });
  //     item.sub.map((item2) => {
  //       if (item2 === userId) heroId = item.user_id;
  //     });
  //   });
  //   // console.log({ heroId });
  //   // console.log({ userId });
  //   const heroInfo = tUsers.find((item) => item._id === heroId);
  //   // console.log({ heroInfo });

  //   return `${heroInfo.department} ${heroInfo.lastname} ${heroInfo.name}`;
  // };

  const searchUser = (userId) => {
    //1. selSurveySeasonInfo.relation_360のbossとpartner, subを検索してuserIdを探す
    //2. 探したオブジェクトのuser_id（本人のIDを取得
    //3. _idでtUserを検索して名前、所属などの情報をReturn
    //*userIdが所属されているrelationが複数ある場合は後ろの方の本人idに上書きされるのでtoken情報を確認しarrayで追加
    let heroId = [];
    const { survey_token } = tUsers.find((item) => item._id === userId);

    // 配信対象(isAnswerd)に応じて {$target$} に列挙する hero を絞り込む
    //   0=未回答のみ / 5=回答済みのみ / 9・99・その他=全件
    const statusMatches = (status) => {
      if (isAnswerd === 0) return status === 0;
      if (isAnswerd === 5) return status === 5;
      return true;
    };

    selSurveySeasonInfo.relation_360.map((item) => {
      item.boss.map((item2) => {
        if (item2 === userId) {
          const t = survey_token.find(
            (item3) =>
              statusMatches(item3.survey_status) &&
              item3.hero_id === item.user_id &&
              item3.survey_season_id === item.survey_season_id
          );
          if (t) {
            heroId.push(item.user_id);
          }
        }
      });
      item.partner.map((item2) => {
        if (item2 === userId) {
          const t = survey_token.find(
            (item3) =>
              statusMatches(item3.survey_status) &&
              item3.hero_id === item.user_id &&
              item3.survey_season_id === item.survey_season_id
          );
          if (t) {
            heroId.push(item.user_id);
          }
        }
      });
      item.sub.map((item2) => {
        if (item2 === userId) {
          const t = survey_token.find(
            (item3) =>
              statusMatches(item3.survey_status) &&
              item3.hero_id === item.user_id &&
              item3.survey_season_id === item.survey_season_id
          );
          if (t) {
            heroId.push(item.user_id);
          }
        }
      });
    });
    let targetText = '';
    for (let i = 0; i < heroId.length; i++) {
      const heroInfo = tUsers.find((item) => item._id === heroId[i]);
      if (i === 0) {
        targetText += `${heroInfo.lastname} ${heroInfo.name}`;
      } else {
        targetText += `、${heroInfo.lastname} ${heroInfo.name}`;
      }
    }
    // console.log({ tUsers });
    // console.log({ heroInfo });

    return targetText;
  };
  //テストメール配信
  const sendTestMailHandler = async () => {
    let mailList = {}; //最終分類用
    try {
      // console.log({ rowKeys });
      message.loading({ content: 'テストメール配信中...', key: 'mail' });
      const selMtInfo = mtInfo.find((item) => item._id === selMtId);
      const testMailString = testMailValue
        .replace(/\s+/g, '') //文字列の中の空白を削除
        .replace(/(^[;]+)|([;]+$)/g, ''); //文字列前後の「;」を削除
      let testMail = [];
      let testMailArr = [];
      if (testMailString) {
        testMail = testMailString.split(';');
        testMail.map((element) => {
          testMailArr.push(element);
        });
      }

      let personalizations = [];
      testMailArr.map((record) => {
        personalizations.push({
          to: [
            {
              email: record,
            },
          ],
          substitutions: {
            email: record,
            fullname: '【テスト　太郎】',
            familyname: '【テスト】',
            company: '【テスト株式会社】',
            department: '【テスト部署名】',
            department1: '【テスト部署名】',
            department2: '【テスト部署名2】',
            department3: '【テスト部署名3】',
            department4: '【テスト部署名4】',
            department5: '【テスト部署名5】',
            department6: '【テスト部署名6】',
            department7: '【テスト部署名7】',
            tname: '【テスト研修】',
            target: '【テスト対象者】',
            emp_no: '【テスト社員番号】',
            init_pass: '【テスト初期パスワード】',
            survey_display_name: '【テスト診断表示名】',
            first_delivery_date: '【4月21日(火)】',
            due_datetime: '【2026年4月21日（火）18:00】',
            extended_due_datetime: '【2026年4月28日（火）18:00】',
            multiple_choice_count: '【00】',
            free_text_count: '【00】',
            time_required: '【15】',
          },
        });
      });
      mailList = {
        personalizations: personalizations,
        from: {
          email: selMtInfo.from_mail, // 送信元アドレス
          name: selMtInfo.from_name, // 送信者名
        },
        subject: selMtInfo.subject,
        html: selMtInfo.body.replace(/\r?\n/g, '<br>'),
        substitutionWrappers: ['{$', '$}'],
        headers: {
          'X-Sent-Using': 'SendGrid-API',
        },
      };
      // console.log({ mailList });
      // const sendMailResult = { data: { success: false } };
      const sendMailResult = await Axios.post('/api/sendMail', {
        mailList: mailList,
        operation_log: 'SurveyTestMailSend',
      });
      if (sendMailResult.data.success) {
        message.success({
          content: 'メール送信完了！',
          key: 'mail',
          duration: 2,
        });
        return sendMailResult;
      } else {
        message.error({
          // サーバーが返す具体的な失敗原因を表示（無ければ汎用文言）
          content: sendMailResult.data.error || 'メール送信に失敗しました。',
          key: 'mail',
          duration: 4,
        });
        console.log({ sendMailResult });
        throw new Error('メール送信に失敗しました。');
      }
    } catch (error) {
      console.log(error);
      message.error({
        content: 'メール配信で問題が発生しました。',
        key: 'mail',
        duration: 2,
      });
    }
  };

  const onChangeMtInfo = (value) => {
    if (value) {
      setSelMtId(value);
    }
    // console.log(e);
  };

  const showConfirm = async () => {
    const targetCount = isAnswerd === 99 ? selectedRowKeys.length : gUsers.length;
    confirm({
      title: `${targetCount}名にメールを本当に配信しますか？`,
      content:
        'メール配信処理が完了し、ホームへ自動遷移されるまで、そのままお待ちください。',
      async onOk() {
        const result = await sendMailHandler();
        if (result) {
          message.success({
            content: 'メールの配信が完了しました。ホームに戻ります。',
            key: 'mail',
            duration: 2,
          });
          props.history.push('/');
        } else {
          message.error({
            content: 'メール送信に失敗しました。',
            key: 'mail',
            duration: 2,
          });
          throw new Error('メール送信に失敗しました。');
        }
      },
      async onCancel() {
        message.success({
          content: 'メール配信を取り消しました。',
          key: 'mail',
          duration: 2,
        });
      },
    });
  };
  const onChangeSurvey = (v) => {
    // setValue({
    //   ...value,
    //   survey_code: v,
    //   survey_id: surveyInfo.find((item) => item.survey_code === v)._id,
    // });
    setSelSurvey(survey.find((item) => item.survey_code === v));
    setSelMtId('');
  };
  const onChangeCCHandler = (e) => {
    setCCMailValue(e.currentTarget.value);
  };

  const onChangeBCCHandler = (e) => {
    setBCCMailValue(e.currentTarget.value);
  };

  const onChangeTestHandler = (e) => {
    setTestMailValue(e.currentTarget.value);
  };
  const csvDownloadHandler = async (event) => {
    event.preventDefault();
    // console.log({ gUsers });
    try {
      message.loading({
        content: 'データ作成中...',
        key: 'makecsv',
        duration: 20,
      });
      const tempData = {};
      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet('sheet1');
      const worksheet = workbook.getWorksheet('sheet1');
      let columns = [
        { header: 'ID', key: 'user_id' },
        { header: '会社名', key: 'company' },
        { header: '部署名', key: 'department' },
        { header: 'eメール', key: 'email' },
        { header: '名前', key: 'fullname' },
        { header: '社員番号', key: 'empNo' },
        { header: 'ロール', key: 'roletext' },
      ];
      worksheet.columns = columns;
      for (let i = 0; i < gUsers.length; i++) {
        const element = gUsers[i];
        tempData.user_id = element._id;
        tempData.company = element.company;
        tempData.department = element.department;
        tempData.email = element.email;
        tempData.fullname = element.fullName;
        tempData.empNo = element.emp_no;
        tempData.roletext = element.roleText;

        worksheet.addRow(tempData);
      }
      const uint8Array = await workbook.xlsx.writeBuffer();
      const blob = new Blob([uint8Array], {
        type: 'application/octet-binary',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      if (selQuestionSetId) {
        let selQuestionSetInfo = questionSet.find(
          (item) => item._id === selQuestionSetId
        );
        a.download = `Recurrent_Sruvey_RawData_${selSurveySeasonInfo.season_name}_${selQuestionSetInfo.set_name}_${isAnswerd}.xlsx`;
      } else {
        a.download = `Recurrent_Sruvey_RawData_${selSurveySeasonInfo.season_name}_${isAnswerd}.xlsx`;
      }
      a.click();
      // ダウンロード後は不要なのでaタグを除去
      a.remove();
      // console.log({ excelData });
      // console.log(excelData.length);
      message.success({
        content: 'ダウンロード完了！',
        key: 'makecsv',
        duration: 2,
      });
    } catch (error) {
      console.log({ error });
      message.error({
        content: 'ダウンロード失敗！',
        key: 'makecsv',
        duration: 2,
      });
    }
  };

  const rowSelection = isAnswerd === 99 ? {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  } : undefined;

  // テーブル強化 PJ Ph.3 拡大: <Column> → columns 配列。rowSelection（チェックボックス）が
  // あるため reservedWidth で幅を予約。テキスト列はソート + 省略。
  const rawColumns = [
    ellipsisColumn({
      title: '名前',
      dataIndex: 'fullName',
      key: 'fullName',
      width: 160,
      sorter: textSorter('fullName'),
    }),
    ellipsisColumn({
      title: 'メール',
      dataIndex: 'email',
      key: 'email',
      width: 220,
      sorter: textSorter('email'),
    }),
    ellipsisColumn({
      title: '会社',
      dataIndex: 'company',
      key: 'company',
      width: 180,
      sorter: textSorter('company'),
    }),
    ellipsisColumn({
      title: '部署',
      dataIndex: 'department',
      key: 'department',
      width: 160,
      sorter: textSorter('department'),
    }),
  ];

  const { columns, components, scroll, wrapRef } = useResizableColumns(
    rawColumns,
    { reservedWidth: 32 }
  );

  // 名前・メールでの表示絞り込み（送信対象・CSVは gUsers 全体のまま。あくまで一覧からの検索用）
  const displayedUsers = gUsers.filter((u) => {
    const nameOk =
      !searchName ||
      (u.fullName || '').toLowerCase().includes(searchName.toLowerCase());
    const emailOk =
      !searchEmail ||
      (u.email || '').toLowerCase().includes(searchEmail.toLowerCase());
    return nameOk && emailOk;
  });
  const isSearching = !!(searchName || searchEmail);

  return (
    <PageContainer fluid>
      <div style={{ marginTop: 16, marginBottom: 16 }}>
          ■絞り込み｜企業選択
          <Select
            showSearch
            style={{
              marginBottom: 10,
              marginLeft: 5,
              marginRight: 5,
              width: 200,
            }}
            placeholder="企業選択"
            optionFilterProp="children"
            onChange={onChangeGroup}
            value={selGroupCode}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {groups.map((element) => {
              // console.log({ element });
              return (
                <Option value={element.group_code} key={element._id}>
                  {element.group_name}
                </Option>
              );
            })}
          </Select>
          {selGroupInfo.survey_season && (
            <Fragment>
              サーベイシーズン選択:
              <Select
                showSearch
                style={{
                  marginBottom: 10,
                  marginLeft: 5,
                  marginRight: 5,
                  width: 250,
                }}
                placeholder="シーズン選択"
                optionFilterProp="children"
                onChange={onChangeSeasonFilter}
                value={selSurveySeasonIdFilter}
                defaultValue={selGroupInfo.survey_season[0].season_name}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {selGroupInfo.survey_season.map((element) => {
                  return (
                    <Option value={element._id} key={element._id}>
                      {element.season_name}
                    </Option>
                  );
                })}
              </Select>
              {questionSet.length > 0 && (
                <Select
                  showSearch
                  style={{
                    marginBottom: 10,
                    marginLeft: 5,
                    marginRight: 5,
                    width: 200,
                  }}
                  placeholder="設問セット選択"
                  optionFilterProp="children"
                  onChange={onChangeQuestionSet}
                  value={selQuestionSetId}
                  defaultValue={questionSet[0].set_name}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {questionSet.map((element) => {
                    return (
                      <Option value={element._id} key={element._id}>
                        {element.set_name}
                      </Option>
                    );
                  })}
                </Select>
              )}
            </Fragment>
          )}
          <Fragment>
            実施選択：
            <Select
              showSearch
              style={{
                marginBottom: 10,
                marginLeft: 5,
                marginRight: 5,
                width: 150,
              }}
              placeholder="回答選択"
              optionFilterProp="items"
              onChange={onChangeAnswer}
              value={isAnswerd}
              disabled={!selSurveySeasonId}
            >
              <Option value={9} key={9}>
                全体
              </Option>
              <Option value={0} key={0}>
                未回答
              </Option>
              <Option value={5} key={5}>
                回答済み
              </Option>
              <Option value={99} key={99}>
                ユーザー選択
              </Option>
            </Select>
          </Fragment>
          {/* <span style={{ marginLeft: 8 }}>
            {hasSelected ? ` ${selectedRowKeys.length}項目選択中` : ''}
          </span> */}
          <Button
            onClick={csvDownloadHandler}
            disabled={!selSurveySeasonId}
          >
            CSVダウンロード
          </Button>
          <Fragment>
            　対象者：{gUsers.length}名
            {isAnswerd === 99 && `（選択中：${selectedRowKeys.length}名）`}
            {isSearching && `（表示：${displayedUsers.length}名）`}
          </Fragment>
        </div>
        <div style={{ marginBottom: 16 }}>
          名前：
          <Input
            allowClear
            placeholder="名前検索"
            style={{ width: 180, marginLeft: 5, marginRight: 15 }}
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
          />
          メール：
          <Input
            allowClear
            placeholder="メール検索"
            style={{ width: 220, marginLeft: 5, marginRight: 15 }}
            value={searchEmail}
            onChange={(e) => setSearchEmail(e.target.value)}
          />
          <Button
            onClick={() => {
              setSearchName('');
              setSearchEmail('');
            }}
          >
            クリア
          </Button>
        </div>
        <div ref={wrapRef}>
          <Table
            columns={columns}
            components={components}
            scroll={scroll}
            rowSelection={rowSelection}
            dataSource={displayedUsers}
            size="middle"
            rowKey="_id"
          />
        </div>
        <Text strong>メールテンプレートを選択してください。（必須）</Text>
        <div>
          <Select
            showSearch
            style={{
              width: 400,
            }}
            placeholder="サーベイ選択"
            optionFilterProp="children"
            onChange={onChangeSurvey}
            value={selSurvey.survey_code}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {survey.map((element) => {
              // console.log({ element });
              return (
                <Option value={element.survey_code} key={element._id}>
                  {element.survey_name}
                </Option>
              );
            })}
          </Select>
          <Select
            showSearch
            style={{
              marginLeft: 10,
              marginRight: 10,
              marginBottom: 10,
              width: 600,
            }}
            placeholder="テンプレート選択"
            optionFilterProp="children"
            onChange={onChangeMtInfo}
            value={selMtId}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {mtInfo.map((element) => {
              // console.log({ element });
              if (element.survey_code === selSurvey.survey_code) {
                return (
                  <Option value={element._id} key={element._id}>
                    {element.mt_name}
                  </Option>
                );
              }
            })}
          </Select>
          <br />
          <br />
          <Text strong>テストメールを送信します。</Text>
          <br />
          Test Mail To：
          <Input
            placeholder="メールアドレスを「;」区切りで入力してください"
            allowClear
            style={{
              marginLeft: 10,
              marginRight: 10,
              marginBottom: 10,
              width: 350,
            }}
            onChange={onChangeTestHandler}
            value={testMailValue}
          />
          <Button
            onClick={sendTestMailHandler}
            disabled={!testMailValue || !selMtId}
          >
            メール発送
          </Button>
          <br />
          <Text strong>本メールを送信します。</Text>
          <br />
          CC：
          <Input
            placeholder="メールアドレスを「;」区切りで入力してください"
            allowClear
            style={{
              marginLeft: 10,
              marginRight: 10,
              marginBottom: 10,
              width: 350,
            }}
            onChange={onChangeCCHandler}
            value={ccMailValue}
          />
          BCC：
          <Input
            placeholder="メールアドレスを「;」区切りで入力してください"
            allowClear
            style={{
              marginLeft: 10,
              marginRight: 10,
              marginBottom: 10,
              width: 350,
            }}
            onChange={onChangeBCCHandler}
            value={bccMailValue}
          />
          <Button
            type="primary"
            onClick={showConfirm}
            disabled={!selGroupCode || !selSurveySeasonId || !selMtId || (isAnswerd === 99 && selectedRowKeys.length === 0)}
          >
            メール発送
          </Button>
        </div>
    </PageContainer>
  );
};

export default SurveyMailSendPage;
